import React, { Component } from 'react';
import { Field, reduxForm, change } from 'redux-form';
require(`../assets/${process.env.PAGE}/css/contract.css`);
import { Modal, Button, Row, Col, Checkbox } from 'react-bootstrap';
import axios from 'axios';
require(`../assets/${process.env.PAGE}/css/custom-modal.css`);

class Contract extends Component {

    constructor(props) {
        super(props);
        this.state = { 
            showModal: false,
            contractText: false
        };

        this.acceptContract = this.acceptContract.bind(this);
        this.closeContract = this.closeContract.bind(this);
        this.openContract = this.openContract.bind(this);
    }

    componentWillMount() {
        if (!this.props.hasOwnProperty('text')) {
            const ROOT_URL = process.env.API_URL;
            const config = {
                headers:
                    {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
                    }
            };
            axios.get(`${ROOT_URL}${this.props.contractEndpoint}`, config)
            .then((response)=> {
                this.setState({
                    contractText: response.data.body
                });
                this.props.dispatch(change(this.props.form, 'contract_accepted', response.data.accepted));
            });
        }
    }

    closeContract() {
        this.setState({ ...this.state, showModal: false });
    }

    openContract() {
        this.setState({ ...this.state, showModal: true });
    }

    acceptContract(dispatch) {
        this.props.dispatch(change(this.props.form, 'contract_accepted', true));
        this.setState({
            showModal: false
        });
    }

    render() {
        const { handleSubmit, submitting, checked } = this.props;
        return (
            <Row className="terms_row">
                <Col className="terms_col terms_checkbox text-center" xs={12} md={6} lg={6}>
                    <Field 
                        name="contract_accepted"
                        label={this.props.label}
                        component={(props) =>
                            <Checkbox checked={props.input.value} onClick={this.openContract}>{props.label} </Checkbox>
                        }
                    />
                </Col>
                <Col className="terms_col" xs={12} md={6} lg={6}>
                    <Button className={"btn btn-warning btn-sm pd-simple-button pd-button-contract " + (checked ? 'pd-button-accepted-contract' : '') }  onClick={this.openContract} disabled={submitting}>{submitting ? 'Cargando...' : checked ? 'Leído y aceptado' : 'Por favor, leer y aceptar'}</Button>
                    <Modal className="custom-modal" show={this.state.showModal} onHide={this.closeContract} bsSize="large">
                        <form onSubmit={handleSubmit(this.props.onSubmit)}>
                            <Modal.Header>
                                <Modal.Title>{this.props.label}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body className="custom-modal-body" dangerouslySetInnerHTML={{__html: (this.state.contractText || this.props.text)}}>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    type="submit"
                                    bsStyle="success"
                                    onClick={this.acceptContract}
                                    disabled={submitting || (!this.props.hasOwnProperty('text') && this.state.contractText === false)}>
                                        Estoy de Acuerdo
                                </Button>
                                <Button onClick={this.closeContract}>Cancelar</Button>
                            </Modal.Footer>
                        </form>
                    </Modal>
                </Col>
            </Row>
        );
    }
}

Contract = reduxForm()(Contract);

export default Contract;


/** WEBPACK FOOTER **
 ** ./src/components/Contract.js
 **/